module.exports = __webpack_public_path__ + "static/ticker-close-icon-gray.d37b0801.png";